import { withParams } from "vuelidate";
export default (function (pattern) { return withParams({ type: 'regex', pattern: pattern }, function (value, parentVM) {
    if (!value)
        return true;
    var sPattern = typeof pattern === "function" ? pattern.call(this) : pattern;
    return new RegExp(sPattern).test(value);
}); });



//////////////////
// WEBPACK FOOTER
// ./src/Validators/regex.ts
// module id = 964
// module chunks = 24